function App() {
  return (
    <meta
      http-equiv="refresh"
      content="0;url=https://web-app.voicemaker.media/off-site-invitate.html?shareLang=zh_TW&inviteType=0&secret=bo9Q7voaoywwumlfBmPHV44T860JOnOtoP8tTjYLsLM"
    />
  );
}

export default App;
